export default "__VITE_ASSET__fddeffcc__"